<template>
    <div class="animated fadeIn responsables">

        <Request
                ref="requestUsers"
                :onRequestSuccess="onRequestSuccess"
                root="/responsable/list">
            <slot slot="body">
                <b-row>
                    <b-col @click="goto(user.id)" class="responsable"  :key="'user' + userIndex" v-for="user, userIndex in dataUsers" lg="3">
                        <img class="responsable-img" :src="user.avatar" />
                        <h5 class="responsable-name"  >{{user.firstname}} {{user.lastname}}</h5>
                    </b-col>
                </b-row>
            </slot>
        </Request>

    </div>
</template>

<style>

    .responsables .responsable {

    }

    .responsables .responsable {
        cursor: pointer;
        margin-bottom: 40px;
        text-align: center;
    }

    .responsables .responsable .responsable-img {
        border-radius: 50%;
    }

    .responsables .responsable .responsable-name {
        margin-top: 10px;
    }
</style>

<script>
    import Request from '../../../components/Request'
    export default {
        name: 'Responsables',
        components: {
            Request
        },
        props: {
        },
        mounted() {
            this.requestUsers()
        },
        data: function () {
            return {
                Core: window.Core,
                dataUsers: []
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccess(data) {
                this.dataUsers = []
                if (data.users !== undefined) {
                    this.dataUsers = data.users
                }
            },
            requestUsers() {
                this.$refs.requestUsers.clearArgs()
                this.$refs.requestUsers.request()
            },
            goto(userId) {
                let link = Core.Definition.getDefinition('/evenements/reserver/responsable/') + userId
                this.$router.push(link)

            }
        }
    }
</script>
